import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Linkedin } from "lucide-react";
import { useStore } from "../../context/StoreContext";
import api, { img } from "../../lib/api";
import { toast } from "sonner";

const COLS = [
  { title: "Shop", links: [["All Products", "/shop"], ["Face", "/collections/face"], ["Hair", "/collections/hair"], ["Body", "/collections/body"], ["Wellness", "/collections/wellness"], ["Gift Sets", "/collections/gift-sets"]] },
  { title: "Our Story", links: [["Our Story", "/our-story"], ["The Meghalaya Story", "/meghalaya"], ["Journal", "/journal"], ["Rituals", "/rituals"]] },
  { title: "Support", links: [["FAQs", "/faq"], ["Shipping", "/policy/shipping"], ["Returns", "/policy/returns"], ["Track Order", "/track"], ["Contact", "/contact"]] },
  { title: "Legal", links: [["Privacy Policy", "/policy/privacy"], ["Terms & Conditions", "/policy/terms"], ["Return & Exchange Policy", "/policy/returns"], ["Shipping Policy", "/policy/shipping"], ["Cookie Policy", "/policy/cookies"]] },
];

export default function Footer() {
  const { settings } = useStore();
  const [email, setEmail] = useState("");
  const social = settings.social || {};

  const subscribe = async (e) => {
    e.preventDefault();
    try { const r = await api.post("/newsletter", { email }); toast.success(r.data.message); setEmail(""); }
    catch { toast.error("Please enter a valid email"); }
  };

  return (
    <footer className="bg-forest text-ivory relative grain overflow-hidden mt-24">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-16 lg:py-24 relative">
        <div className="grid lg:grid-cols-2 gap-14 pb-16 border-b border-ivory/15">
          <div className="max-w-md">
            {settings.logo_dark
              ? <img src={img(settings.logo_dark)} alt="the IAH" className="h-16 w-auto mb-5" />
              : <div className="serif text-5xl tracking-[0.12em] mb-5">IAH</div>}
            <p className="text-ivory/70 leading-relaxed">Inspired by the untouched beauty of Meghalaya. Crafted with science. Made for every skin.</p>
          </div>
          <div>
            <h4 className="serif text-3xl mb-3">Stay Close to Nature</h4>
            <p className="text-ivory/60 text-sm mb-5">Join us for skincare rituals, nature stories and new launches.</p>
            <form onSubmit={subscribe} className="flex items-center gap-4 border-b border-ivory/30 pb-2 max-w-md">
              <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required data-testid="newsletter-email"
                placeholder="Your email" className="flex-1 bg-transparent outline-none placeholder:text-ivory/40 text-ivory" />
              <button data-testid="newsletter-submit" className="text-xs uppercase tracking-[0.18em] hover:opacity-70">Subscribe</button>
            </form>
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-10 py-16">
          {COLS.map((c) => (
            <div key={c.title}>
              <div className="eyebrow text-ivory/50 mb-5">{c.title}</div>
              <ul className="space-y-3">
                {c.links.map(([label, to]) => (
                  <li key={label}><Link to={to} className="text-sm text-ivory/75 hover:text-ivory transition-colors">{label}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-6 pt-10 border-t border-ivory/15">
          <div className="text-xs text-ivory/50">© {new Date().getFullYear()} IAH. All rights reserved. Inspired by Meghalaya.</div>
          <div className="flex items-center gap-5">
            <a href={social.instagram || "#"} target="_blank" rel="noreferrer" aria-label="Instagram"><Instagram size={18} strokeWidth={1.4} className="hover:opacity-70" /></a>
            <a href={social.facebook || "#"} target="_blank" rel="noreferrer" aria-label="Facebook"><Facebook size={18} strokeWidth={1.4} className="hover:opacity-70" /></a>
            <a href={social.youtube || "#"} target="_blank" rel="noreferrer" aria-label="YouTube"><Youtube size={18} strokeWidth={1.4} className="hover:opacity-70" /></a>
            <a href={social.linkedin || "#"} target="_blank" rel="noreferrer" aria-label="LinkedIn"><Linkedin size={18} strokeWidth={1.4} className="hover:opacity-70" /></a>
          </div>
        </div>
      </div>
    </footer>
  );
}
